import React from 'react';

import { getFullNameWithInitial } from 'Utilities/formatHelper';
import i18n from 'Utilities/i18n';

import styles from './ConnectionDetails.module.scss';

type Props = LLUConnection | Invitation;

const ConnectionDetails: React.FC<React.PropsWithChildren<Props>> = (props) => {
  let name = '';
  let email = '';
  let id = '';

  if ('receiver' in props) {
    name = getFullNameWithInitial(props.receiver);
    email = props.receiver.email;
    id = props.id;
  } else {
    name = getFullNameWithInitial({
      firstName: props.CaregiverFirstName,
      lastName: props.CaregiverLastName,
    });
    email = props.CaregiverEmail;
    id = props.ConnectionID;
  }

  return (
    <div id={`connectionDetails-${id}`} className="d-flex flex-column">
      {/* Name */}
      <span id="caregiverName" className={styles.name}>
        {name}
      </span>

      {/* Email Address */}
      <div className={`d-flex flex-column mt-3 ${styles.field}`}>
        <span id="email-label" className="text-md">
          {i18n.t('LLU.emailAddress')}
        </span>
        <span id="email-value" className="ltrInRtl">
          {email}
        </span>
      </div>
    </div>
  );
};

export default ConnectionDetails;
